<div class="update-firmware">
  <div class="header">
    <div class="d-flex justify-content-end">
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        alt="close button"
        class="pointer-cursor"
        (click)="closeDialog()"
      />
    </div>

    <div class="d-flex mt-4 pt-2 pb-2 mx-1">
      <h2 class="heading1 m-auto px-4 text-center">
        {{ "UPDATE_FIRMWARE" | translate }}
      </h2>
    </div>
  </div>
  <div class="main-container py-2 px-3">
    <div class="pb-95">
      <div class="info-box d-flex align-items-start">
        <img
          src="/assets/svg/ico-info-blue.svg"
          class="info-icon mr-2"
          alt="info"
        />
        <span class="info-text">
          {{ "UPDATE_FIRMWARE_APP_NOTE" | translate }}
        </span>
      </div>

      <ul class="firmware-steps">
        <li>{{ "UPDATE_FIRMWARE_STEP_1" | translate }}</li>
        <li>{{ "UPDATE_FIRMWARE_STEP_2" | translate }}</li>
        <li>{{ "UPDATE_FIRMWARE_STEP_3" | translate }}</li>
        <li>{{ "UPDATE_FIRMWARE_STEP_4" | translate }}</li>
      </ul>

    </div>

    <div class="row bottom-container justify-content-center pb-2">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          type="button"
          (click)="closeDialog()"
        >
          {{ "CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
